/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BedType } from './BedType';
import {
    BedTypeFromJSON,
    BedTypeFromJSONTyped,
    BedTypeToJSON,
    BedTypeToJSONTyped,
} from './BedType';

/**
 * 
 * @export
 * @interface FindAllBedTypes200Response
 */
export interface FindAllBedTypes200Response {
    /**
     * List of bed types
     */
    data?: Array<BedType>;
}

/**
 * Check if a given object implements the FindAllBedTypes200Response interface.
 */
export function instanceOfFindAllBedTypes200Response(value: object): value is FindAllBedTypes200Response {
    return true;
}

export function FindAllBedTypes200ResponseFromJSON(json: any): FindAllBedTypes200Response {
    return FindAllBedTypes200ResponseFromJSONTyped(json, false);
}

export function FindAllBedTypes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllBedTypes200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(BedTypeFromJSON)),
    };
}

export function FindAllBedTypes200ResponseToJSON(json: any): FindAllBedTypes200Response {
    return FindAllBedTypes200ResponseToJSONTyped(json, false);
}

export function FindAllBedTypes200ResponseToJSONTyped(value?: FindAllBedTypes200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(BedTypeToJSON)),
    };
}

